<template>
  <div class="copilot-overlay" v-if="isOpen">
    <div class="copilot-modal">
      <button class="copilot-close-global" @click="close" title="Cerrar">
        <i class="el-icon-close"></i>
      </button>
      <div
        class="copilot-sidebar-wrapper"
        :class="{ 'sidebar-open': sidebarOpen }"
        @click.self="sidebarOpen = false"
      >
        <CopilotSidebar @close-sidebar="sidebarOpen = false" />
      </div>
      <CopilotChat ref="chat" @toggle-sidebar="sidebarOpen = !sidebarOpen" />
    </div>
  </div>
</template>

<script>
import CopilotSidebar from "./CopilotSidebar";
import CopilotChat from "./CopilotChat";

export default {
  name: "CopilotModal",
  components: { CopilotSidebar, CopilotChat },
  data() {
    return { sidebarOpen: true };
  },
  computed: {
    isOpen() {
      return this.$store.getters["copilot/isOpen"];
    }
  },
  watch: {
    isOpen(val) {
      document.body.style.overflow = val ? "hidden" : "";
    }
  },
  methods: {
    close() {
      // If doc preview is open → close only the preview and stay in chat
      const chat = this.$refs.chat;
      if (chat && chat.hasDocumentOpen) {
        chat.closeDocPanel();
        return;
      }
      this.$store.dispatch("copilot/close");
    },
    handleEsc(e) {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleEsc);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEsc);
    document.body.style.overflow = "";
  }
};
</script>

<style lang="scss">
.copilot-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  animation: copilotFadeIn 0.18s ease;
}
.copilot-modal {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
  animation: copilotSlideUp 0.22s ease;
}

/* Botón cerrar — dentro del modal, esquina superior derecha */
.copilot-close-global {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 10;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e4eaf6;
  background: #fff;
  color: #606266;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.15s;
  &:hover {
    border-color: #2d2b55;
    color: #2d2b55;
  }
}

@keyframes copilotFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes copilotSlideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Sidebar wrapper */
.copilot-sidebar-wrapper {
  display: flex;
  flex-shrink: 0;

  &:not(.sidebar-open) {
    display: none;
  }
}

@media (max-width: 768px) {
  .copilot-sidebar-wrapper {
    position: fixed;
    inset: 0;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.4);
    display: none;

    &.sidebar-open {
      display: flex;
    }

    .copilot-sidebar {
      display: flex !important;
      animation: copilotSlideRight 0.2s ease;
    }
  }
}

@keyframes copilotSlideRight {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

/* ─── Global copilot styles ─── */
.nav-tag {
  font-size: 12px;
  background: #eeedfe;
  color: #3c3489;
  border-radius: 5px;
  padding: 2px 8px;
  font-family: monospace;
  display: inline-block;
  margin: 1px 0;
}
.copilot-action-chip {
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 0.5px solid #3ecfb4;
  color: #0f6e56;
  background: #e1f5ee;
  cursor: pointer;
  transition: background 0.15s;
  display: inline-block;
  margin: 3px 3px 0 0;
}
.copilot-action-chip:hover {
  background: #9fe1cb;
}
</style>
